export const checkForUnsavedChangesBeforeUnload = ({ hasUnsavedChanges, confirmMessage }) => {
  window.onbeforeunload = hasUnsavedChanges
    ? (e) => {
        e = e || window.event;

        if (e) {
          e.returnValue = confirmMessage;
        }

        return confirmMessage;
      }
    : null;
};
